import React from 'react'

import Heading from './Heading';
import Button from './Button';

export default function AboutCard(props) {
  return (
    <div className='w-full'>
        <Heading>
            <Button ReducedMotion = {props.ReducedMotion} setHover={props.setHover} link={'/about'}>
                <div className='text-blue keplersemi text-[24px]'>ABOUT</div>
            </Button>
        </Heading>
    </div>
  )
}
